import { Directive, ElementRef } from '@angular/core';
import { FormControl, FormControlName, NgControl } from '@angular/forms';

// Attaches the native HTML Element to all bound form control names.
@Directive({
  selector: '[formControlName]',
  standalone: false
})
export class FormControlNavtiveElementDirective {
  constructor(
    private ElementRef: ElementRef,
    private FormControlItem: NgControl
  ) {}

  ngOnInit(): void {
    const { nativeElement } = this.ElementRef;
    if (this.FormControlItem instanceof FormControlName) {
      const { control } = this.FormControlItem;
      if (control) {
        Object.assign(control, { nativeElement });
      }
    }

    // At the moment this only works on form control names.
    if (this.FormControlItem instanceof FormControl) {
      Object.assign(this.FormControlItem, { nativeElement });
    }
  }
}
